import {TreeNode} from '@/script/Tree.mjs'

export default class TreeDocNode extends TreeNode {
    get data() {
        return super.data
    }

    set data(data) {
        this._update(
            'data',
            data,
            () => super.data = data
        )
    }

    get firstChild() {
        return super.firstChild
    }

    set firstChild(node) {
        this._update(
            'firstChild',
            node,
            () => super.firstChild = node
        )
    }

    get isDeleted() {
        return void 0 === this.tree.getNode(this.id)
    }

    get isFolded() {
        return (
            null !== this.firstChild &&
            this.#isFolded
        )
    }

    set isFolded(isFolded) {
        this._update(
            'isFolded',
            isFolded,
            () => this.#isFolded = isFolded
        )
    }

    get isHidden() {
        return this.#isHidden
    }

    set isHidden(isHidden) {
        this._update(
            'isHidden',
            isHidden,
            () => this.#isHidden = isHidden
        )
    }

    get lastChild() {
        return super.lastChild
    }

    set lastChild(node) {
        this._update(
            'lastChild',
            node,
            () => super.lastChild = node
        )
    }

    get nextSibling() {
        return super.nextSibling
    }

    set nextSibling(node) {
        this._update(
            'nextSibling',
            node,
            () => super.nextSibling = node
        )
    }

    get parent() {
        return super.parent
    }

    set parent(node) {
        this._update(
            'parent',
            node,
            () => super.parent = node
        )
    }

    get prevSibling() {
        return super.prevSibling
    }

    set prevSibling(node) {
        this._update(
            'prevSibling',
            node,
            () => super.prevSibling = node
        )
    }

    change(type, newValue, oldValue) {
        this.tree._changeNode(this, type, newValue, oldValue)
    }

    export(transform = a => a) {
        const {isFolded, isHidden} = this

        return transform({
            ...super.export(),
            isFolded,
            isHidden,
        })
    }

    _update(prop, newValue, update) {
        const oldValue = this[prop]

        if (oldValue !== newValue) {
            update()
            this.tree._updateNode(this, prop, newValue, oldValue)
        }

        return oldValue
    }

    #isFolded = false
    #isHidden = false
}
